var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCallBlockIcon = function SvgCallBlockIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.01,
    d: "M0 0h34v34H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D2329",
    fillRule: "evenodd",
    d: "M26.817 20.24a3.19 3.19 0 0 0-3.507-.669L20.187 20.9a12.03 12.03 0 0 1-7.087-7.087l1.328-3.123a3.19 3.19 0 0 0-.616-3.507l-3.05-2.996a3.19 3.19 0 0 0-4.505 0L4.642 5.812a4.92 4.92 0 0 0-1.2 5.068 31.26 31.26 0 0 0 19.677 19.677 5 5 0 0 0 1.573.255 4.93 4.93 0 0 0 3.506-1.455l1.615-1.615a3.19 3.19 0 0 0 0-4.505zm1.487 6.004-1.615 1.615a2.83 2.83 0 0 1-2.9.68A29.12 29.12 0 0 1 5.46 10.21a2.83 2.83 0 0 1 .68-2.901l1.615-1.615a1.06 1.06 0 0 1 1.51 0l2.995 2.986c.306.307.395.77.223 1.168l-1.508 3.507a1.06 1.06 0 0 0 0 .754 14.16 14.16 0 0 0 8.935 8.936c.243.092.512.092.755 0l3.495-1.51c.404-.173.873-.08 1.18.235l2.985 2.985c.4.42.39 1.08-.02 1.488M23.905 17a6.896 6.896 0 1 0-.025-13.792A6.896 6.896 0 0 0 23.905 17m3.38-3.528a4.75 4.75 0 0 1-5.919.66l6.577-6.578a4.75 4.75 0 0 1-.659 5.918m-6.758-6.757a4.75 4.75 0 0 1 5.918-.659l-6.577 6.577a4.75 4.75 0 0 1 .659-5.918",
    clipRule: "evenodd"
  })));
};
export default SvgCallBlockIcon;